export { serve, stop, pushRequest } from '@snapwyr/dashboard';
export type { DashboardConfig, LogEntry } from '@snapwyr/dashboard';
